export default {
  Actions: {
    FETCH_WORKSPACES_TEMPLATES_SUCCESS: 'workspace_templates/FETCH_WORKSPACES_TEMPLATES_SUCCESS',
    DELETE_WORKSPACE_TEMPLATE_SUCCESS: 'workspace_templates/DELETE_WORKSPACE_TEMPLATE_SUCCESS',
    UPDATE_WORKSPACE_TEMPLATE_SUCCESS: 'workspace_templates/UPDATE_WORKSPACE_TEMPLATE_SUCCESS',
  },
  State: {
    WORKSPACES_TEMPLATES_BY_SLUG: 'WORKSPACES_TEMPLATES_BY_SLUG',
  },
};
